module.exports = __webpack_public_path__ + "img/horse-portrait-painting-6.470ebe60.png";